import type { CSSProperties, ReactNode } from 'react'

import { Icon } from '@percent/lemonade'
import cardStyles from './CardRow.module.scss'

export interface CardRowProps {
  onRemove?: () => void
  removeLabel?: string
  removeTestId?: string
  onClick?: () => void
  children: ReactNode
  testId?: string
  style?: CSSProperties
}

function CloseButton({
  onRemove,
  removeLabel,
  removeTestId
}: {
  onRemove: () => void
  removeLabel?: string
  removeTestId?: string
}) {
  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation()
        onRemove()
      }}
      className={cardStyles.closeButton}
      aria-label={removeLabel ?? 'Remove'}
      data-testid={removeTestId}
    >
      <Icon name="close" size={4} />
    </button>
  )
}

export function CardRow({
  onRemove,
  removeLabel,
  removeTestId,
  onClick,
  children,
  testId,
  style
}: Readonly<CardRowProps>) {
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cardStyles.card} style={style} data-testid={testId}>
        {onRemove && <CloseButton onRemove={onRemove} removeLabel={removeLabel} removeTestId={removeTestId} />}
        {children}
      </button>
    )
  }

  return (
    <div className={cardStyles.card} style={style} data-testid={testId}>
      {onRemove && <CloseButton onRemove={onRemove} removeLabel={removeLabel} removeTestId={removeTestId} />}
      {children}
    </div>
  )
}
